/**
 * The static loader painted by index.html (`#hs-boot-shell`) before the JS
 * bundle has downloaded, so in-app WebViews never sit on a blank white page.
 * The app removes it once React has painted its first screen.
 */
export function removeBootShell(): void {
  document.getElementById("hs-boot-shell")?.remove();
  document.getElementById("hs-boot-shell-styles")?.remove();
}

/**
 * /handshake, /handshake/{checkoutId} (and the legacy /{checkoutId}/handshake
 * form) are unauthenticated entries that redirect to Auth login — they have no
 * checkout token by design and keep the index.html boot shell until they
 * navigate away.
 */
export function isHandshakeEntryPath(
  pathname: string = window.location.pathname,
): boolean {
  return /\/handshake(\/[A-Za-z0-9_-]+)?\/?$/.test(pathname);
}
